// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jn-9","clinicsSelect":"styles_clinicsSelect__2q8Ee"};